var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.359 102.751C52.627 106.182 48.4238 108.399 43.7478 108.399C35.5517 108.399 28.9317 101.749 28.9317 93.5146C28.9317 85.2807 35.5517 78.6303 43.7478 78.6303C48.2137 78.6303 52.2067 80.5832 54.8862 83.7501L60.4553 76.5718C56.1471 72.2965 50.2627 69.6574 43.7478 69.6574C30.613 69.6046 20 80.3193 20 93.4619C20 106.657 30.613 117.319 43.7478 117.319C50.3152 117.319 56.2522 114.627 60.5079 110.352L55.359 102.751Z",
    fill: "#21254F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3249 70.6074H65.2899V116.844H75.3249V70.6074Z",
    fill: "#21254F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.964 70.8186H119.929V117.055H129.964V70.8186Z",
    fill: "#21254F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.751 117.266C94.1344 117.266 92.0854 109.877 91.8752 105.707H91.8227V79.3165H82.9961V70.8715H91.8227V61.8986L100.754 56.4622L100.492 63.3237V70.8715H109.528V79.3165H100.492V102.751C100.439 103.068 100.387 103.438 100.387 103.754C100.387 104.071 100.439 104.441 100.492 104.757V105.285C100.859 107.343 102.226 109.032 104.064 109.824C104.8 110.141 105.588 110.299 106.429 110.299C108.32 110.299 110.001 109.455 111.105 108.082C111.367 107.766 111.578 107.449 111.735 107.08C111.735 107.132 111.945 117.266 102.751 117.266Z",
    fill: "#21254F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.491 102.751V104.757C100.438 104.44 100.386 104.071 100.386 103.754C100.438 103.438 100.438 103.068 100.491 102.751Z",
    fill: "#21254F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2294 42C82.2592 42 67.2855 50.7089 58.5114 63.9043H72.697C79.5272 57.1483 88.9317 53.0313 99.282 53.0313C109.632 53.0313 119.037 57.2011 125.867 63.9043H140.053C131.226 50.7089 116.252 42 99.2294 42Z",
    fill: "#E30613"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.491 102.751V104.757C100.438 104.44 100.386 104.071 100.386 103.754C100.438 103.438 100.438 103.068 100.491 102.751Z",
    fill: "#21254F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75.3191,
    fill: "white",
    transform: "translate(20 42)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiti);
export default __webpack_public_path__ + "static/media/citi.e33ce3bd.svg";
export { ForwardRef as ReactComponent };